import { useEffect, useState, useRef } from "react";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db, storage } from "./firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import TurndownService from "turndown";
import ReactMarkdown from "react-markdown";
import { marked } from "marked";
import "./index.css";

const DOC_ID = "Pxx6MWfi0eJXkUIJdfzK";
const turndownService = new TurndownService();

const modules = {
  toolbar: [
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const formats = ["bold", "italic", "underline", "list", "bullet"];

function InformacoesEvento() {
  const [data, setData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [newData, setNewData] = useState({
    hotel: "",
    location: "",
    transfers: "",
    deeplink: "",
    banner: null,
  });
  const [htmlContent, setHtmlContent] = useState("");
  const [bannerPreview, setBannerPreview] = useState(null);
  const fileRef = useRef(null);

  const fetchEventInfo = async () => {
    try {
      const docRef = doc(db, "evento_informacoes", DOC_ID);
      const snap = await getDoc(docRef);

      if (snap.exists()) {
        const docData = snap.data();

        // 🟢 Mapeamento correto dos campos
        const parsedData = {
          hotel: docData.hotel || "",
          location: docData.localizacao || "",
          transfers: docData.transfers || "",
          deeplink: docData.deeplink || "",
          banner: docData.banner || "",
        };

        setData(parsedData);
        setNewData(parsedData);
        setHtmlContent(marked(parsedData.transfers));
        setBannerPreview(parsedData.banner);
      }
    } catch (err) {
      console.error("Erro ao buscar informações:", err);
    }
  };

  useEffect(() => {
    fetchEventInfo();
  }, []);

  const saveChanges = async () => {
    try {
      let bannerURL = bannerPreview;

      if (newData.banner && typeof newData.banner !== "string") {
        const bannerRef = ref(storage, `informacoes/${newData.banner.name}`);
        await uploadBytes(bannerRef, newData.banner);
        bannerURL = await getDownloadURL(bannerRef);
      }

      const markdownTransfers = turndownService.turndown(htmlContent);

      const docRef = doc(db, "evento_informacoes", DOC_ID);

      // 🟢 Salvar usando o nome correto do campo: localizacao
      await updateDoc(docRef, {
        hotel: newData.hotel,
        localizacao: newData.location,
        transfers: markdownTransfers,
        deeplink: newData.deeplink,
        banner: bannerURL,
      });

      // Atualizar estado local
      const updated = {
        hotel: newData.hotel,
        location: newData.location,
        transfers: markdownTransfers,
        deeplink: newData.deeplink,
        banner: bannerURL,
      };

      setData(updated);
      setHtmlContent(marked(markdownTransfers));
      setBannerPreview(bannerURL);
      setIsEditing(false);

      alert("Informações guardadas com sucesso!");
    } catch (err) {
      console.error(err);
      alert("Erro ao guardar.");
    }
  };

  if (!data)
    return <p style={{ textAlign: "center", color: "#6b7280" }}>A carregar...</p>;

  return (
    <div className="table-container">
      <div className="filtros" style={{ height: "10vh" }}></div>

      <table className="table">
        <thead>
          <tr>
            <th>Banner</th>
            <th>Hotel</th>
            <th>Localização</th>
            <th>Deeplink</th>
            <th>Transfers</th>
            <th width="100px">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {data.banner ? (
                <img
                  src={data.banner}
                  alt="Banner"
                  style={{ width: 100, height: 60, objectFit: "cover", borderRadius: "6px" }}
                />
              ) : "—"}
            </td>

            <td>{data.hotel || "—"}</td>

            <td style={{ whiteSpace: "pre-wrap", fontSize: "0.9rem" }}>
              {data.location || "—"}
            </td>

            <td>{data.deeplink || "—"}</td>

            <td style={{ maxHeight: 600, overflow: "auto", fontSize: "0.9rem" }}>
              <ReactMarkdown>{data.transfers}</ReactMarkdown>
            </td>

            <td>
              <button
                className="btn btn-add"
                onClick={() => {
                  setIsEditing(true);
                  setNewData(data);
                  setHtmlContent(marked(data.transfers || ""));
                  setBannerPreview(data.banner || null);
                }}
              >
                Editar
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {isEditing && (
        <div className="drawer">
          <div className="drawer-content">
            <label>Hotel:</label>
            <input
              type="text"
              value={newData.hotel}
              onChange={(e) => setNewData(p => ({ ...p, hotel: e.target.value }))}
            />

            <br /><br />
            <label>Localização:</label>
            <textarea
              value={newData.location}
              onChange={(e) => setNewData(p => ({ ...p, location: e.target.value }))}
              rows={2}
              style={{ width: "100%", resize: "vertical" }}
            />

            <br /><br />
            <label>Deeplink:</label>
            <input
              type="text"
              value={newData.deeplink}
              onChange={(e) => setNewData(p => ({ ...p, deeplink: e.target.value }))}
            />

            <br /><br />
            <label>Transfers:</label>
            <ReactQuill
              theme="snow"
              value={htmlContent}
              onChange={setHtmlContent}
              modules={modules}
              formats={formats}
              style={{ height: "150px", marginBottom: "50px" }}
            />

            <div className="tab-content">
              {bannerPreview && (
                <img
                  src={bannerPreview}
                  alt="Banner Preview"
                  className="banner-noticia"
                />
              )}

              <input
                type="file"
                ref={fileRef}
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  setNewData(p => ({ ...p, banner: file }));
                  setBannerPreview(file ? URL.createObjectURL(file) : null);
                }}
              />
            </div>
          </div>

          <div className="drawer-footer">
            <button className="btn btn-add" onClick={saveChanges}>Guardar</button>
            <button className="btn btn-cancel" onClick={() => setIsEditing(false)}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default InformacoesEvento;
